export function deriveOrganizationSlug(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 48);
}

export function organizationNameWarning(name: string): string | null {
  if (!name.trim()) return null;
  if (deriveOrganizationSlug(name)) return null;
  return 'Use a company name with at least one letter or number so Oracord can create the workspace URL.';
}
